import AccountCircleRoundediIcon from '@mui/icons-material/AccountCircleRounded'
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded'
import Tooltip from '@mui/material/Tooltip'
import { FormattedMessage } from 'react-intl'
import useAuth from '../../hooks/useAuth'

const UserRoleIcon = () => {
  const { isAdmin } = useAuth()
  return (
    <Tooltip
      title={
        <FormattedMessage
          id={`menu.user.tooltip.${isAdmin ? 'admin' : 'user'}`}
        />
      }
    >
      {isAdmin ? <SecurityRoundedIcon /> : <AccountCircleRoundediIcon />}
    </Tooltip>
  )
}

export default UserRoleIcon
